import PolicyDetail from './PolicyDetail'

export default PolicyDetail
